import { useContext } from "react";

import AuthContext from "shared/common/contexts/AuthProvider";

export default function UseAuth() {
  return useContext(AuthContext);
}
